export default function Power(props: any) {
    return (
        <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3929_5320)">
                <rect x="21.5" y="26.0732" width="2" height="10" rx="1" fill="black" />
                <rect x="21.5" y="37.0732" width="2" height="4" rx="1" fill="black" />
                <rect x="31.5" y="12.0732" width="18" height="33" rx="2" stroke="black" strokeWidth="2" />
                <path d="M39.1667 22.0732H45.1667L41.5 26.6232H46.5L38.5 35.0732L40.1667 28.8982H35.5L39.1667 22.0732Z" fill="black" />
                <rect x="35.5" y="8.07324" width="10" height="5" rx="1" fill="black" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.5015 31.2866L22.4939 18.7729L6.17125 44.0731L30.5015 44.0731V44.0731H40.687C40.6844 45.1125 39.8558 46.0731 38.6837 46.0731H6.17125C4.58745 46.0731 3.63204 44.3197 4.49066 42.9889L20.8133 17.6887C21.6028 16.465 23.3936 16.4683 24.1785 17.695L30.5015 27.576V31.2866Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_3929_5320">
                    <rect width="56" height="56" fill="white" transform="translate(0.5 0.0732422)" />
                </clipPath>
            </defs>
        </svg>
    );
}
